/* eslint-disable react/prop-types */
import React from 'react';
import { SectionCard } from '../../../../ui';

import ChatListView from '@/pages/user/components/ChatListView';

/**
 * 成员详情 · 会话记录（S1 抽出的 section）
 * ------------------------------------------------------------------
 * 按 §12.1 的约束排在第 6 位（最后）：它是无界列表（聊天流），
 * 放在中间会把下面所有区块推得很远。
 */
export const SessionSection = (props) => {
  const { coachUserId } = props;
  return (
    <SectionCard title="会话记录">
      <ChatListView userId={coachUserId} userType={2} />
    </SectionCard>
  );
};

export default SessionSection;
